import React, { useEffect, useState } from "react";
import { fetchHqFranchiseOptions } from "../hqFilterUtils";

/**
 * Franchise scope selector for HQ workspace / executive analytics pages.
 * @param {{ api: (path: string, init?: object) => Promise<Response>, value: string, onChange: (id: string) => void }} props
 */
export default function HqFranchiseFilterField({ api, value = "", onChange }) {
  const [franchises, setFranchises] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!api) return undefined;
    let cancelled = false;
    (async () => {
      try {
        const rows = await fetchHqFranchiseOptions(api);
        if (!cancelled) {
          setFranchises(rows);
          setError("");
        }
      } catch (err) {
        if (!cancelled) {
          setFranchises([]);
          setError(err?.message || "Could not load franchises");
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [api]);

  return (
    <>
      <label className="pca-filters__field">
        <span>Franchise</span>
        <select
          className="pca-filters__control"
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
        >
          <option value="">All franchises</option>
          {franchises.map((f) => (
            <option key={f.id} value={String(f.id)}>
              {f.name}
            </option>
          ))}
        </select>
      </label>
      {error ? <p className="pca-error pca-filters__inline-error">{error}</p> : null}
    </>
  );
}
